import React, { memo } from 'react';
import { trackingKeys, useTrackPage } from '@olxeu-a2b/delivery-utils/src/tracking';
import S from './style/DetailsCard';

interface DetailsCardProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  rest?: any[];
}

const DetailsCard: React.FC<DetailsCardProps> = function DeliveryMethodCard({
  title,
  subtitle,
  children,
  ...rest
}) {
  const { deliveryOrderDetailsSeller } = trackingKeys.events;

  const { myDeliveries } = trackingKeys.touchPointPages;

  useTrackPage(deliveryOrderDetailsSeller, {
    touch_point_page: myDeliveries,
  });

  return (
    <S.Card {...rest}>
      <S.Title>{title}</S.Title>
      {typeof subtitle !== 'undefined' && <S.SubTitle>{subtitle}</S.SubTitle>}
      {children}
    </S.Card>
  );
};

export default memo(DetailsCard);
